import { Toast } from '@core/models/toast/toast';
import { Action } from '@ngrx/store';
import {
    TOAST_FLUSH,
    TOAST_SET,
    TOAST_SHOW
} from '../action-types';

export class ShowToastAction implements Action {
    readonly type = TOAST_SHOW;

    constructor(public payload: Toast) {
    }
}

export class SetToastAction implements Action {
    readonly type = TOAST_SET;

    constructor(public payload: Toast) {
    }
}

export class FlushToastAction implements Action {
    readonly type = TOAST_FLUSH;

    constructor() {
    }
}